import React, { useEffect } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import loginTheme from "./loginTheme";

/** Wraps auth routes so admin theme mode does not alter login/signup UI */
export default function AuthThemeProvider({ children }) {
  useEffect(() => {
    document.documentElement.dataset.theme = "auth";
    document.documentElement.style.setProperty("--app-canvas", "transparent");
    document.body.style.backgroundColor = "transparent";
  }, []);

  return (
    <ThemeProvider theme={loginTheme}>
      <CssBaseline enableColorScheme />
      {children}
    </ThemeProvider>
  );
}
